import { RefObject, useRef } from 'react'

export const useLatestValueRef = <T>(value: T): RefObject<T> => {
    const ref = useRef<T>(value)

    ref.current = value

    return ref
}
